import React from 'react';
import { GestureResponderEvent, ImageBackground, StyleSheet, Text, View, TouchableWithoutFeedback, Image } from 'react-native';
import { useDimensions } from 'react-native-web-hooks';
import Game from '../shell/Game';
import useFontSize from '../shell/hooks/useFontSize';
import { onDiscordPressed, onPatreonPressed, onSteamPressed } from '../shell/utils/appManagementFunctions';
import { useAppSelector } from '../store/hooks';
import { selectMenu, setMenu } from '../store/slices/menuSlice';
import { store } from '../store/store';
import { parseRequire } from '../utils/parseImageUrl';

interface EndingScreenProps {
}

export const EndingScreen: React.FC<EndingScreenProps> = ({ }) => {
    const image = parseRequire(require("@lss/common/game/assets/images/Extras/alexEnd.webp"));
    const menuSlice = useAppSelector(selectMenu);
    const { width, height } = useDimensions().window;
    const styles = StyleSheet.create({
        container: {
            backgroundColor: "black",
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: 10000,
        },
        backgroundImage: {
            position: "absolute",
            width,
            height,
            justifyContent: "center"
        },

        textWrapper: {
            backgroundColor: "#00000080",
            padding: "10%",
            flex: 1,
            width: "100%",
            alignItems: "center",
            flexDirection: "row",
            alignSelf: "center",
            textAlign: "center",
            justifyContent: "center",
            alignContent: "center"
        },
        text: {
            fontFamily: "serif",
            fontWeight: "bold",
            textShadowColor: 'rgba(0, 0, 0, 0.5)',
            textShadowRadius: 1,
            textShadowOffset: { width: 1, height: 1 },
            textAlign: "center",
            color: "white",
            display: "flex",
            flexDirection: "column",
            fontSize: useFontSize(4)

        }

    });
    const _onPatreonPressed = (event: GestureResponderEvent) => {
        event.preventDefault();
        event.stopPropagation();
        onPatreonPressed();
    };
    const _onDiscord = (event: GestureResponderEvent) => {
        event.preventDefault();
        event.stopPropagation();
        onDiscordPressed();
    };
    const _onSteam = (event: GestureResponderEvent) => {
        event.preventDefault();
        event.stopPropagation();
        onSteamPressed();
    };
    const onBackgroundClicked = (event: GestureResponderEvent) => {
        event.preventDefault();
        event.stopPropagation();
        store.dispatch(setMenu({ showEnding: null, display: true }));
    };
    return (
        <View style={styles.container}>
            <TouchableWithoutFeedback style={styles.backgroundImage} onPress={(e) => onBackgroundClicked(e)}>
                <View>
                    <ImageBackground style={styles.backgroundImage} source={image}>

                        {/* <Text style={{ fontStyle: "italic" }}>beta</Text> */}
                        {menuSlice.showEnding === "normal" ?
                            <View style={styles.textWrapper}>

                                <Text selectable={false} style={styles.text}>
                                    <Text style={{ flexDirection: "row", }}>
                                        Thanks for playing version ({Game.version}) of{"\n"}
                                    </Text>
                                    <Text style={{ alignSelf: "center" }}>
                                        <Text style={{ color: "red" }}>Long Story Short!</Text>{"\n"}{"\n"}
                                    </Text>
                                    <Text style={{ alignSelf: "center" }}>
                                        <Text style={{}}>Check my <Text onPress={_onDiscord} style={{ color: "#f9664e", zIndex: 5, }}>Discord</Text> for more updates and news!</Text>
                                    </Text>
                                </Text>
                            </View>
                            :
                            <View style={styles.textWrapper}>

                                <Text selectable={false} style={styles.text}>
                                    <Text style={{ flexDirection: "row", }}>
                                        Thanks for playing the <Text style={{ fontStyle: "italic" }}>alpha ({Game.version})</Text> version of <Text style={{ color: "red" }}>Long Story Short!</Text>{"\n"}{"\n"}
                                        {/* <Text style={{ color: "#ef1767" }}> Vanessa's path.</Text>{"\n"}{"\n"} */}
                                        {"\n"}
                                    </Text>
                                    <Text style={{ alignSelf: "center" }}>
                                        <Text style={{}}>Please wishlist the game on <Text onPress={_onSteam} style={{ color: "#366992", zIndex: 5, }}>Steam</Text> to help me out release faster and bigger updates.</Text>
                                        {"\n"}{"\n"}
                                    </Text>
                                    <Text style={{ alignSelf: "center" }}>
                                        <Text style={{}}>Check my <Text onPress={_onDiscord} style={{ color: "#f9664e", zIndex: 5, }}>Discord</Text> for more updates and news!</Text>
                                    </Text>
                                </Text>
                            </View>

                        }
                    </ImageBackground>
                    {/* <ImageBackground style={styles.backgroundImage} source={image}>


                        {menuSlice.showEnding === "normal" ?
                            <View style={styles.textWrapper}>

                                <Text selectable={false} style={styles.text}>
                                    <Text style={{ flexDirection: "row", }}>
                                        Oh no! It looks like you're playing a path which has no new content YET in this <Text style={{ fontStyle: "italic" }}>alpha</Text> release. The content in this alpha is for:
                                        <Text style={{ color: "#ef1767" }}> Ann's corruption route.</Text>{"\n"}{"\n"}
                                        <Text>If you want to play the alpha content, either load a save for the implemented route/s or just skip fast through the story :).</Text>{"\n"}{"\n"}
                                    </Text>
                                    <Text style={{ alignSelf: "center" }}>
                                        <Text style={{}}>Don't forget to check out the <Text onPress={_onPatreonPressed} style={{ color: "#f9664e", zIndex: 5, }}>Patreon</Text> for more updates and news!</Text>
                                    </Text>
                                </Text>
                            </View>
                            :
                            <View style={styles.textWrapper}>

                                <Text selectable={false} style={styles.text}>
                                    <Text style={{ flexDirection: "row", }}>
                                        Thanks for playing the <Text style={{ fontStyle: "italic" }}>alpha</Text> version ({Game.version}) of{"\n"}
                                    </Text>
                                    <Text style={{ alignSelf: "center" }}>
                                        <Text style={{ color: "red" }}>Long Story Short!</Text>{"\n"}{"\n"}
                                    </Text>
                                    <Text style={{ alignSelf: "center" }}>
                                        <Text style={{}}>Don't forget to check out the <Text onPress={_onPatreonPressed} style={{ color: "#f9664e", zIndex: 5, }}>Patreon</Text> for more updates and news!</Text>
                                    </Text>
                                </Text>
                            </View>}
                    </ImageBackground> */}
                </View>
            </TouchableWithoutFeedback>
        </View>
    );
};